import type { SearchTileDensity } from '../searchTileDensity'

/**
 * CRO compact density must stay a single horizontal row (CRO-6924).
 * Grouped option cards break that geometry, so secondary/grouped alternatives
 * intentionally collapse to the primary single-row tile for the experiment.
 * Legacy Optimizely compact density still allows grouped tiles.
 */
export function shouldUseGroupedAccommodationSearchTile({
  density,
  hasSecondaryOffer,
  isMetaSearch = false,
}: {
  density: SearchTileDensity
  hasSecondaryOffer: boolean
  isMetaSearch?: boolean
}): boolean {
  return density !== 'cro-compact' && hasSecondaryOffer && !isMetaSearch
}
